var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-icon',{staticClass:"bage-back",attrs:{"name":"play-circle-o"},on:{"click":_vm.go_back}})
}
var staticRenderFns = []

export { render, staticRenderFns }